import React, { ReactElement, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	SalesByRepBar,
	SalesThisMonthGauge,
	UserStatsTable,
} from "./charts";
import moment from "moment";

import "./dashboard.scss";

export const DashboardPage = (): ReactElement => {
	const [date, setDate] = useState<Date | null>(new Date());

	const rate = document.body.getAttribute("data-exr");

	return (
		<Container fluid className="dashboard-container">
			{/* Dashboard Header */}
			<div className="dashboard-header-card">
				<div className="dashboard-header-main">
					<div className="dashboard-icon-wrapper">
						<i className="fa fa-tachometer"></i>
					</div>
					<div className="dashboard-info">
						<h1 className="dashboard-title">Dashboard</h1>
						<p className="dashboard-subtitle">Sales performance and key metrics overview</p>
					</div>
				</div>
				<div className="dashboard-header-actions">
					<div className="date-picker-wrapper">
						<i className="fa fa-calendar"></i>
						<DatePicker
							className="form-control date-picker-input"
							dateFormat="MM/yyyy"
							selected={date}
							showMonthYearPicker
							onChange={(_date: Date | null) => {
								setDate(_date);
							}}
						/>
					</div>
				</div>
			</div>

			<Row>
				{/* Left Column - Tables */}
				<Col lg={8}>
					<div className="dashboard-card">
						<div className="card-header">
							<i className="fa fa-users"></i>
							<span>Team Performance</span>
						</div>
						<div className="card-body">
							<UserStatsTable date={date} />
						</div>
					</div>

					<div className="exchange-rate-card">
						<i className="fa fa-exchange"></i>
						<span>
							Velsoft posted US exchange rate for{" "}
							<strong>{moment().format("MMMM")}: {rate}</strong>{" "}
							($1.00 USD = {rate} CAD)
						</span>
					</div>
				</Col>

				{/* Right Column - Charts */}
				<Col lg={4}>
					<div className="dashboard-card">
						<div className="card-header">
							<i className="fa fa-bullseye"></i>
							<span>Sales Goal</span>
						</div>
						<div className="card-body chart-body">
							<SalesThisMonthGauge date={date} />
						</div>
					</div>

					<div className="dashboard-card">
						<div className="card-header">
							<i className="fa fa-bar-chart"></i>
							<span>Sales By Rep</span>
						</div>
						<div className="card-body chart-body">
							<SalesByRepBar date={date} />
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
};
